export default __webpack_public_path__ + "static/green-school_3-edb706fa3943ef3175da0718b18a2dde.png";